export const Rights = [
    "WEB_MODULE_IMPERSONATE_WRITE"
]
